import { handleSignOut } from '../pages/App/App';
import { makeToast } from './makeToast';
import { safeRetrieve } from './safeStoring';


const dBridgeTableSearch = (tableName, searchQuery, searchCols, filtersDict={}) => {
    return new Promise((resolve, reject) => {
        const apiKey = safeRetrieve('APIKEY_v2') || '';
        const apiUrl = process.env.REACT_APP_API_URL || '';
        fetch(`${apiUrl}/api/dbridge/v1/search`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                table_name: tableName,
                filters_dict: filtersDict,
                filter_user_column: "user_name",
                search_query: searchQuery,
                search_cols: searchCols,
            })
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error calling search: ${response.status}`, errorData);
                    if (response.status === 401) {
                        handleSignOut();
                    } else {
                        makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
                    }
                    resolve([]);  // resolve with an empty array on error
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            resolve(data.body);  // resolve with the fetched data
        })
        .catch((error) => {
            console.error(`Error calling search: ${error}`);
            makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
            resolve([]);  // resolve with an empty array on error
        });
    });
}


export const getIndexAll = (tableName) => {
    return dBridgeTableSearch(tableName, '', []);
}


export const getIndexFilters = (tableName, filtersDict) => {
    return dBridgeTableSearch(tableName, '', [], filtersDict);
}


export const getSearchHits = (tableName, searchQuery, searchCols, filtersDict, getHighlights=true) => {
    return dBridgeTableSearch(tableName, searchQuery, searchCols, filtersDict)
}


export const dBridgeTableInsert = (tableName, entry) => {
    return new Promise((resolve, reject) => {
        const apiKey = safeRetrieve('APIKEY_v2') || '';
        const apiUrl = process.env.REACT_APP_API_URL || '';
        fetch(`${apiUrl}/api/dbridge/v1/insert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                table_name: tableName,
                set_user_column: "user_name",
                data: [entry]
            })
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error calling insert: ${response.status}`, errorData);
                    if (response.status === 401) {
                        handleSignOut();
                    } else {
                        makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
                    }
                    resolve({});  // resolve with empty entry on error
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            resolve(data.body[0]);  // resolve with the body (inserted entry)
        })
        .catch((error) => {
            console.error(`Error calling insert: ${error}`);
            makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
            resolve({});  // resolve with empty entry on error
        });
    });
}


export const dBridgeTableDelete = (tableName, filterKey, filterValue) => {
    return new Promise((resolve, reject) => {
        const apiKey = safeRetrieve('APIKEY_v2') || '';
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const url = `${apiUrl}/api/dbridge/v1/delete_where?api_key=${apiKey}&table_name=${tableName}&filter_key=${filterKey}&filter_value=${filterValue}`;
        fetch(url, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error calling delete_where: ${response.status}`, errorData);
                    if (response.status === 401) {
                        handleSignOut();
                    } else {
                        makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
                    }
                    resolve(false);  // resolve with false on error
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            resolve(data.body);  // resolve with the body (true)
        })
        .catch((error) => {
            console.error(`Error calling delete_where: ${error}`);
            makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
            resolve(false);  // resolve with false on error
        });
    });
}


export const dBridgeTableEdit = (tableName, filtersDict, newValuesDict) => {
    return new Promise((resolve, reject) => {
        const apiKey = safeRetrieve('APIKEY_v2') || '';
        const apiUrl = process.env.REACT_APP_API_URL || '';
        fetch(`${apiUrl}/api/dbridge/v1/edit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                table_name: tableName,
                filters_dict: filtersDict,
                new_values_dict: newValuesDict
            })
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error calling edit: ${response.status}`, errorData);
                    if (response.status === 401) {
                        handleSignOut("expiration");
                    } else {
                        makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
                    }
                    resolve(false);  // resolve with false on error
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            resolve(data.body);  // resolve with the body (true)
        })
        .catch((error) => {
            console.error(`Error calling edit: ${error}`);
            makeToast("Connessione al database non riuscita, verifica la tua connessione e riprova.", 'danger');
            resolve(false);  // resolve with false on error
        });
    });
}
